import { Component } from 'react';
import styled from 'styled-components';
import { SC_BLACK, SC_GRAY } from '../themes/DefaultTheme';

const BreadcrumbElement = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: ${SC_GRAY};
  padding: 0px;
  margin: 0px;
  background-color: inherit;

  & > strong {
    font-weight: 600;
    color: ${SC_BLACK};
  }

  &&& > a {
    cursor: pointer;
    color: ${SC_GRAY};
    background-color: inherit;
    text-decoration: none;
    padding: 0;
    margin: 0;
  }

  &&& > a:hover {
    color: ${SC_BLACK};
    text-decoration: underline;
  }
` as any;

export class Breadcrumb extends Component {
  public render() {
    return <BreadcrumbElement>{this.props.children}</BreadcrumbElement>;
  }
}
